import { Injectable } from '@angular/core';
import { OPTION_TRANSLATIONS } from '../constants/option-translations';

@Injectable({
  providedIn: 'root'
})
export class OptionTranslateService {
  // This method is used to get options using key and lang
  getOptions(key: 'nationalities' | 'roles' | 'partnerTypes' | 'standardOption' | 'tyeOfAddUser' | 'membershipYearsList' | 'applicationDays' | 'stampPositions' | 'svs_enquiryTypes' | 'info_marketingForm' | 'ResourceCategories', lang: any): any[] {
    return OPTION_TRANSLATIONS[key].map((item: any) => ({
      label: item[lang],
      value: key === 'standardOption' ? item[lang] : item.value,
    }));
  }
}
